// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3HKwl","card":"Cards_card__3TmJ3","infected":"Cards_infected__2LJ7Z","recovered":"Cards_recovered__2r-RW","deaths":"Cards_deaths__3Sn76"};